import { cva, type VariantProps } from 'class-variance-authority';
import { clsx } from 'clsx';
import type React from 'react';

const button = cva('button', {
  variants: {
    intent: {
      primary: ['bg-hb-orange', 'text-white', 'font-medium', 'border-transparent', 'lg:hover:bg-hb-orange-hover'],
      secondary: ['bg-white', 'text-black', 'border-neutral-950'],
      dark: ['bg-neutral-950', 'text-white', 'border-transparent'],
      icon: ['border-neutral-200', 'bg-white', 'text-neutral-950'],
      navigationLight: ['border-neutral-950', 'bg-white', 'text-neutral-950', 'border', 'box-border'],
      navigationDark: ['bg-neutral-600', 'text-white'],
    },
    size: {
      icon: ['h-9', 'w-9', 'p-2', 'inline-flex', 'justify-center', 'items-center', 'rounded-sm', 'border'],
      default: [
        'h-9',
        'px-4',
        'py-2',
        'inline-flex',
        'justify-center',
        'items-center',
        'border',
        'box-border',
        'font-robotoCondensed',
        'uppercase',
        'font-medium',
        'leading-none',
      ],
      navigation: ['h-10', 'w-10', 'items-center', 'justify-center', 'inline-flex'],
    },
  },
  defaultVariants: {
    intent: 'primary',
    size: 'default',
  },
});

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement>, VariantProps<typeof button> {}

export default function Button({ intent, size, className, children, disabled, ...rest }: ButtonProps) {
  return (
    <button
      className={clsx(button({ intent, size, class: className }), disabled ? '!bg-gray-300 cursor-not-allowed' : '')}
      {...rest}
      disabled={disabled}
    >
      {children}
    </button>
  );
}
